// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"BaseModal_modalHeader__1L0sP","close":"BaseModal_close__2Ibvx"};